"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CrudContext = react_1.default.createContext({
    selectedItem: undefined,
    isCreate: false,
    isUpdate: false,
});
exports.default = CrudContext;
